import { Box, Text } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsTransferSourceTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const getTypeText = (sourceType: BankingValueObjectsTransferSourceTypeEnum): string => {
  const type: Record<BankingValueObjectsTransferSourceTypeEnum, string> = {
    payroll: i18n.t('banking.transfers.source_types.payroll'),
    invoice: i18n.t('banking.transfers.source_types.invoices'),
    expensable: i18n.t('banking.transfers.source_types.expenses'),
  }

  return type[sourceType] || i18n.t('banking.transfers.source_types.unknown')
}

export const SourceType = ({ type }: { type: BankingValueObjectsTransferSourceTypeEnum }) => {
  return (
    <Box alignItems="center" flexDirection="row" gap="s8">
      <Text.Normal size="200">{getTypeText(type)}</Text.Normal>
    </Box>
  )
}
